export const getAuthToken = () =>
  localStorage.getItem("authToken") || sessionStorage.getItem("authToken");

export const getAuthHeaders = () => {
  const token = getAuthToken();

  return token
    ? {
        Authorization: `Bearer ${token}`,
      }
    : {};
};

export const clearClientSession = () => {
  localStorage.clear();
  sessionStorage.clear();
};
